
<div class="container my-4 contactContent" id="" >
  <h3 class="page-title" style="max-width: 1000px;">{{'ContactAssessor.TitleExclusions'|translate}}</h3>
  <p style="font-style: italic"><strong>{{'ContactAssessor.Number'|translate}} </strong></p>
  <p [innerHTML]="'ContactAssessor.ExclusionsDescription' | translate" ></p>
  <hr>
    <form [formGroup]="contactForm" (ngSubmit)="submit()">
      <p class="form-label">{{'ContactAssessor.Name'|translate}} <span class="color-red">*</span></p>
      <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px; margin-bottom: 20px;">
        <div class="form-group col-md-6" style="display: flex; flex-direction: column; align-items: center; width: 49%;">

          <input type="text" formControlName="firstName" class="form-control" id="inputFirst-General" placeholder="{{'ContactAssessor.FirstName' | translate}}">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('firstName', 'required')) {
              {{'ContactAssessor.Required'|translate}}
            }
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="text" formControlName="lastName" class="form-control" id="inputLast-General" placeholder="{{'ContactAssessor.LastName' | translate}}">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('lastName', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 20px;">
        <p class="form-label">{{ 'ContactAssessor.Email' | translate}} <span class="color-red">*</span></p>
        <input type="email" class="form-control" formControlName="email" placeholder="{{'ContactAssessor.Email' | translate}}">
        <div class="invalid-feedback" style="display: block">
          @if (hasError('email', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>
      <p class="form-label">{{ 'ContactAssessor.Phone' | translate}}  <span class="color-red">*</span></p>
      <div class="form-row" style="margin-bottom: 20px;">
        <div class="form-group col-12">
          <input class="form-control"  type="text" appPhoneMask placeholder="{{'ContactAssessor.Phone' | translate}}"  formControlName="phone" id="inputPhone-General"  >
          <div class="invalid-feedback" style="display: block">
            @if (hasError('phone', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>

      <div class="form-group" style="margin-bottom: 20px;">
        <p class="form-label" style="margin-bottom: 20px;">AIN ({{ 'ContactAssessor.Ain' | translate}})</p>
        <input type="text" class="form-control" appAinMask formControlName="ain" placeholder="XXXX-XXX-XXX">

      </div>

      <p class="form-label">{{'ContactAssessor.Address'| translate}} <span class="color-red">*</span></p>
      <app-certificate-address
        [parentFormGroup]="contactForm"
        streetNumber="number"
        streetDirection="direction"
        streetName="street"
        streetType="type"
        unitNumber="unit"
        city="city"
        zipCode="zipCode"

        >
      </app-certificate-address>

      <p class="form-label" style="margin-top: 20px;">
        {{'ContactAssessor.RadioClaim' | translate}} <span class="color-red">*</span>
      </p>
      <div class="form-group d-flex align-items-center gap-3">
        <div class="form-check">
          <input class="form-check-input" formControlName="checkStatus" value="Yes" name="checkStatus" type="radio" id="checkStatusYes">
          <label class="form-check-label" for="checkStatusYes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" formControlName="checkStatus" value="No" name="checkStatus" type="radio" id="checkStatusNo">
          <label class="form-check-label" for="checkStatusNo">No</label>
        </div>
      </div>
      <div class="invalid-feedback d-block">
        @if (hasError('checkStatus', 'required')) {
          {{ 'ContactAssessor.Required' | translate}}
        }
      </div>

      <p class="form-label">
        {{'ContactAssessor.ParentChildRadio' | translate}} <span class="color-red">*</span>
      </p>
      <div class="form-group d-flex align-items-center gap-3">
        <div class="form-check">
          <input class="form-check-input" formControlName="parentToChild" value="Yes" name="parentToChild" type="radio" id="parentToChildYes">
          <label class="form-check-label" for="parentToChildYes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" formControlName="parentToChild" value="No" name="parentToChild" type="radio" id="parentToChildNo">
          <label class="form-check-label" for="parentToChildNo">No</label>
        </div>
      </div>
      <div class="invalid-feedback d-block">
        @if (hasError('parentToChild', 'required')) {
          {{ 'ContactAssessor.Required' | translate}}
        }
      </div>

      <p class="form-label">
        {{'ContactAssessor.TransferRadio' | translate}} <span class="color-red">*</span>
      </p>
      <div class="form-group d-flex align-items-center gap-3">
        <div class="form-check">
          <input class="form-check-input" formControlName="over55" value="Yes" name="over55" type="radio" id="over55Yes">
          <label class="form-check-label" for="over55Yes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" formControlName="over55" value="No" name="over55" type="radio" id="over55No">
          <label class="form-check-label" for="over55No">No</label>
        </div>
      </div>
      <div class="invalid-feedback d-block">
        @if (hasError('over55', 'required')) {
          {{ 'ContactAssessor.Required' | translate}}
        }
      </div>

      <p class="form-label">
        {{'ContactAssessor.TransferRelated' | translate}} <span class="color-red">*</span>
      </p>
      <div class="form-group d-flex align-items-center gap-3">
        <div class="form-check">
          <input class="form-check-input" formControlName="naturalDisaster" value="Yes" name="naturalDisaster" type="radio" id="naturalDisasterYes">
          <label class="form-check-label" for="naturalDisasterYes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" formControlName="naturalDisaster" value="No" name="naturalDisaster" type="radio" id="naturalDisasterNo">
          <label class="form-check-label" for="naturalDisasterNo">No</label>
        </div>
      </div>
      <div class="invalid-feedback d-block">
        @if (hasError('naturalDisaster', 'required')) {
          {{ 'ContactAssessor.Required' | translate}}
        }
      </div>

      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Description' | translate}}</p>
      <div class="form-group">

        <textarea class="form-control" formControlName="description"  id="inputDescription-General" rows="4" placeholder="Type here"></textarea>
      </div>
      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Attachment' | translate}} (PDF or Docx)</p>
      <div class="form-group">
        <app-file-upload formControlName="file" [progress]="progress"></app-file-upload>
        <div class="invalid-feedback" style="display: block">
          @if (hasError('file', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
          @if (hasError('file', 'requiredFileType')) {
            Only PDF, Docx
          }
          @if (hasError('file', 'requiredFileSize')) {
            Size to exceeds 10 MB
          }
        </div>
      </div>

      <div class="form-group" style="margin-top: 15px;">
        <app-captcha [form]="contactForm" captchaFieldName="recaptchaReactive"></app-captcha>
        <div class="invalid-feedback" style="display: block">
          @if (hasError('recaptchaReactive', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>

      <button type="submit" class="btn btn-primary mr-4" style="margin-top: 15px;">Submit</button>@if (success) {
      <span>Successfully Submitted</span>
    }

  </form>

</div>
